<template>
	<c-dialog ref="dialog" :height="360" :width="450" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="审批结果" required>
				<c-radio-group name="audit_state" :options="auditStateDic" v-model="auditState"></c-radio-group>
			</c-form-item>
			<c-form-item label="审批备注" :required="auditState == 3">
                <c-input type="textarea" name="audit_remark" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
    name: 'rechargeBatchAudit',

	components: {
	},

	data() {
		return {
            ids:[],                 //待批量审批的充值记录ID
            //审批结果
            auditStateDic: [
                {name: '审核通过',value: 2,color: 'blue'},
                {name: '审核拒绝',value: 3,color: 'red'},
            ],
            auditState:2               //审批状态
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
        open(ids) {
            this.ids = ids;
            this.auditState = 2;
            this.$refs.form.clear();
            this.$refs.form.set({audit_state: this.auditState});
			this.$refs.dialog.open({
				title: '充值申请批量审批（共' + ids.length + '条）'
			});
		},

		/*******提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/account/recharge/audit_batch',
				rule: {
                    audit_state: '请选择审批结果',
                    audit_remark: [{
                        type: 'empty',
                        message: '请输入审批备注',
                        skip: () => {
                            return this.auditState != 3;
                        }
                    }]
				},
				dataFormatter: data => {
                    data.ids = this.ids;
                    return data;
				},
				success: (data, res) => {
					next();
                    this.$message({
                        message: res.message,
                        type: data && data.fail_count > 0 ? 'warn' : 'success'
                    });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>
